import React from 'react';
import DashboardContainer from './DashboardContainer';

const DashboardView = () => {
  return <DashboardContainer />;
};

export default DashboardView;
